"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDistrict = exports.parseRegion = exports.parseAddr = void 0;
const react_1 = require("react");
const dcAPI_1 = __importDefault(require("../api/dcAPI"));
const parseAddr = (addr, district) => {
    const addrList = addr.split(" ");
    let d0 = -1, d1 = -1, d2 = -1;
    try {
        if (addrList.length > 3) {
            d0 = district.findIndex((i) => i.name === addrList[0]);
            d1 = district[d0].child.findIndex((i) => i.name === addrList[1] + " " + addrList[2]);
            d2 = district[d0].child[d1].child.findIndex((i) => i === addrList[3]);
        }
        else {
            d0 = district.findIndex((i) => i.name === addrList[0]);
            const biggerIdx = district[d0].child.findIndex((i) => i.name === addrList[1] + " " + addrList[2]);
            if (biggerIdx > -1) {
                d1 = biggerIdx;
            }
            else {
                d1 = district[d0].child.findIndex((i) => i.name === addrList[1]);
                d2 = district[d0].child[d1].child.findIndex((i) => i === addrList[2]);
            }
        }
    }
    catch (e) { }
    return { d0, d1, d2 };
};
exports.parseAddr = parseAddr;
// 이 함수는 주소를 파싱해서 선택 리스트에서 잘 보이도록 합니다.
const parseRegion = (region, district) => {
    const regionList = region.split(" ");
    // 띄어쓰기 단위로 파싱함
    let d0 = -1, d1 = -1, d2 = -1;
    try {
        if (regionList.length > 3) {
            //만약 주소가 4개 이상으로 이뤄질 경우
            // 1 + 23 + 4 형태로 찾음
            d0 = district.findIndex((i) => i.name === regionList[0]);
            d1 = district[d0].child.findIndex((i) => i.name === regionList[1] + " " + regionList[2]);
            d2 = district[d0].child[d1].child.findIndex((i) => i === regionList[3]);
        }
        else {
            // 그게 아닐경우 각각 띄어쓰기 단위로 찾음
            d0 = district.findIndex((i) => i.name === regionList[0]);
            // 근데 만약에 23 형태로 된 주소가 가운데 있을 경우 찾음
            const biggerIdx = district[d0].child.findIndex((i) => i.name === regionList[1] + " " + regionList[2]);
            if (biggerIdx > -1) {
                // 있을경우 그렇게 처리함
                d1 = biggerIdx;
            }
            else {
                // 없을경우 1 + 2 + 3 형태로 찾음
                d1 = district[d0].child.findIndex((i) => i.name === regionList[1]);
                d2 = district[d0].child[d1].child.findIndex((i) => i === regionList[2]);
            }
        }
    }
    catch (e) { }
    return { d0, d1, d2 };
};
exports.parseRegion = parseRegion;
// 주소와 관련된 커스텀 훅입니다.
let isAlreadyDistr = false;
const useDistrict = (params, setQuery, setDistrict, popup) => {
    const getDistrict = async () => {
        const { data: { result_data: { district }, }, } = await dcAPI_1.default.recommendDistrict();
        if (params.region !== "") {
            setQuery((s) => ({ ...s, ...(0, exports.parseRegion)(params.region, district) }));
        }
        isAlreadyDistr = true;
        setDistrict(district);
    };
    (0, react_1.useEffect)(() => {
        if (!isAlreadyDistr) {
            // 주소를 바로 가져옴
            isAlreadyDistr = true;
            getDistrict();
        }
    }, []);
};
exports.useDistrict = useDistrict;
